__turbopack_context__.v({
  "modalContainer": "AboutThisEventModal-module-scss-module__ZGtoqG__modalContainer",
  "modulesWrapper": "AboutThisEventModal-module-scss-module__ZGtoqG__modulesWrapper",
});
